import axios from 'axios';

const API_BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('access_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Only 401 (unauthenticated / invalid token) should log the user out.
    // 403 means authenticated but not permitted — keep session, let component render its message.
    if (error.response?.status === 401) {
      localStorage.removeItem('access_token');
      // Best-effort redirect only if we're inside the app (not on public /where-to-buy)
      if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/where-to-buy') && window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
